import { cn } from "@/lib/utils";
import type * as React from "react";

function Small({
  className,
  children,
  ...props
}: React.HTMLAttributes<HTMLElement>) {
  return (
    <small
      className={cn("font-medium text-sm leading-none", className)}
      data-slot="small"
      {...props}
    >
      {children}
    </small>
  );
}

export { Small };
